import { useMemo } from 'react';
import { useBaseInputProps } from './baseInputProps';

/**
 *
 * @param { string } name - имя поля
 * @param { Object } data - Данные
 * @param { Object } fields - Поля
 * @param { Object } errors - Ошибки
 * @param { function } onChange - handler
 * @param { boolean } isReadOnly - isReadOnly
 * @param {string[]} readOnlyFelds - readOnlyFelds
 * @returns {{
 *  onChange: (function(*, *): *),
 *  description: string,
 *  readOnly: boolean,
 *  controlId: string,
 *  label: string,
 *  value: string,
 *  required: boolean,
 *  maxLength: number,
 *  errors: Array}}
 */
// eslint-disable-next-line max-len
export const useTextInputProps = (name, data, fields, errors, onChange, isReadOnly = false, readOnlyFelds = []) => {
  // eslint-disable-next-line max-len
  const baseProps = useBaseInputProps(name, data, fields, errors, onChange, isReadOnly, readOnlyFelds);
  const maxLength = useMemo(
    () => (fields && fields[name] ? fields[name].max_length : null),
    [fields, name],
  );
  return useMemo(
    () => ({
      ...baseProps,
      maxLength,
    }),
    [baseProps, maxLength],
  );
};

export default useTextInputProps;
